import React, { useState } from 'react';
import { get } from 'lodash';
import { useAutosizeVideos } from 'components/shared/hooks/index';
import request from 'utils/request_ajax';
import { urlIsZiggeo } from 'utils/url';
import { routes } from 'constants/config';
import Recorder from 'components/ui/MediaRecorder';
import RetryButton from 'components/Practice/shared/RetryButton';
import { Spinner } from 'ui';
import ZiggeoMediaPlayer from 'ui/ZiggeoVideo/ZiggeoMediaPlayer';
import EmbedForm from '../embed/EmbedForm';

const ProviderIndependentExampleRecording = props => {
  const { content, apiKey, provider, currentUserId } = props;

  const [loading, setLoading] = useState(false);

  const [embedCode, setEmbedCode] = useState(
    get(content, 'example_recording.embed_code') ||
      get(content, 'exampleRecording.embed_code'),
  );

  const [videoURL, setVideoURL] = useState(
    get(content, 'example_recording.url') ||
      get(content, 'exampleRecording.url'),
  );

  const ziggeoToken = urlIsZiggeo(videoURL);

  const [recording, setRecording] = useState(false);

  const { embedRef, embedContainer } = useAutosizeVideos(embedCode, 0.56);

  const [videoId, setVideoId] = useState(
    get(content, 'example_recording.id') || get(content, 'exampleRecording.id'),
  );

  const questionType =
    get(content, 'question_type') || get(content, 'questionType');

  const [tempEmbedUrl, setTempEmbedUrl] = useState(null);

  const submitUrl = async data => {
    setLoading(true);
    if (!embedCode) {
      request
        .postJSON(routes.QUESTIONS.GOOD_EXAMPLE(content.id), { url: data.url })
        .then(response => {
          setVideoId(get(response, 'example_recording.id'));
          setEmbedCode(get(response, 'example_recording.embed_code'));
          setVideoURL(get(response, 'example_recording.url'));
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
          if (props.onError) {
            props.onError();
          }
        });
    }
  };

  const deleteUrl = () => {
    request.delete(
      routes.QUESTIONS.GOOD_EXAMPLE_RECORDING(content.id, videoId),
    );
    setEmbedCode(null);
    setVideoURL(null);
  };

  const toggleRecording = () => {
    setRecording(!recording);
  };

  const renderForm = () => {
    return embedCode || loading ? null : (
      <div className="EditorElement-uploadArea recordingQuestionUploadArea">
        {questionType === 'webcam_recording' && (
          <Recorder
            id="recording_question"
            provider={provider}
            saveMedia={submitUrl}
            apiKey={apiKey}
            allowUpload
            allowWebcam
            allowDragAndDrop
            trackEvents={false}
            currentUserId={currentUserId}
            onRecording={toggleRecording}
            onRecordingStopped={toggleRecording}
          />
        )}

        {questionType === 'screen_recording' && (
          <Recorder
            id="recording_question"
            provider={provider}
            saveMedia={submitUrl}
            apiKey={apiKey}
            allowUpload
            allowScreen
            allowWebcam={false}
            allowDragAndDrop
            trackEvents={false}
            currentUserId={currentUserId}
            onRecording={toggleRecording}
            onRecordingStopped={toggleRecording}
          />
        )}

        {!recording && (
          <div className="EditorElement-uploadArea">
            <EmbedForm
              onSubmit={e => {
                e.preventDefault();
                submitUrl({ url: tempEmbedUrl });
              }}
              onUrlInput={e => setTempEmbedUrl(e.target.value)}
              isVideo
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      {loading && !embedCode && <Spinner className="p-16 mt-16 mb-16" />}
      {embedCode ? (
        <div
          className="EditorElement-exampleRecordingComplete mt-16"
          ref={embedContainer}
        >
          <div className="Video-redo ta-r p-8">
            <RetryButton onClick={() => deleteUrl()} />
          </div>
          {ziggeoToken && (
            <ZiggeoMediaPlayer
              apiKey={apiKey}
              token={ziggeoToken}
              className="maxh-600"
            />
          )}
          {!ziggeoToken && (
            <div
              ref={embedRef}
              dangerouslySetInnerHTML={{ __html: embedCode }}
            />
          )}
        </div>
      ) : null}
      {renderForm()}
    </>
  );
};

export default ProviderIndependentExampleRecording;
